import { createSignal, For, onMount, Show } from "solid-js";
import { cleanImagePath, fetchGet } from "./API";
import { PageList } from "./components/page-list";
import { MarkerDto } from "./Map";

type Props = {
    data: MarkerDto;
};
type Artist = {
    Id: string;
    Slug: string;
    FirstName: string;
    LastName: string;
}
type ArtworkJson = {
    Id: number;
    Slug: string;
    Title: string;
    Artist: Artist;
    DateRange: string;
    ImageUrl: string;
    Measurements: string;
};
export function NearbyMuseumsInfoWindow (props: Props) {
    const [artworks, setArtworks] = createSignal<ArtworkJson[]>([]);
    const [page, setPage] = createSignal<number>(1);
    const [showBlockTextForArtworkId, setShowBlockTextForArtworkId] = createSignal<number|null>(null);
    const [maxPage, setMaxPage] = createSignal<number>(1);
    const [count, setCount] = createSignal<number>(0);
    const [blockSize, setBlockSize] = createSignal<number>(10);
    const loadPage = async (page: number) => {
        setPage(page);
        await search();
    };
    const getModel = () => {
        return {
            artworkLocationId: props.data.ArtworkLocationId,
            page: page(),
            pageRows: 10
        }
    }
    const search = async () => {
        const model = getModel();
        const response = await fetchGet("/Artist/SolidSearchByArtworkLocationJson", model);
        const json = await response.json();
        if (!json.Success) {
            return;
        }
        const data = json.Data;
        setCount(data.TotalArtworks);
        setMaxPage(data.MaxPage);
        setArtworks(data.Items as ArtworkJson[]);
        return json;
    };
    onMount(async () => {
        await search();
    });
    return (
    <>
        <div style="text-align: left; color: #333; width: 850px;">
            <h2>
                <a href={`/ArtCollection/SPA/${props.data.ArtworkLocationId}`}>{props.data.Name}</a>
            </h2>
            <h4>
                {props.data.City}, {props.data.Country}
            </h4>
            <div style="border-top: 1px dotted #ccc; margin-top: 10px; padding-top: 10px;">
                <div>
                    <PageList page={page} blockSize={blockSize} onClick={loadPage} maxPage={maxPage}></PageList>
                </div>
                <div class="finalist-grid">
                    <For each={artworks()}>{(x) =>
                        <div class="category-image"
                            style={{ "display": "inline-block" }}
                            onMouseOver={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(x.Id); }}
                            onMouseLeave={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(null); }}>
                            <div style={{ "padding": "5px", "background-color": "#333", "text-align": "center", position: "relative" }}>
                                <a href={ `/artworks/${x.Slug}/${x.Artist.Slug}/${x.Id}` } target="_blank">
                                    <img style="width: 150px; height: 150px;" src={ cleanImagePath(x.ImageUrl) + "?mode=crop&format=jpg&width=150&height=150&anchor=topLeft" } />
                                    <Show when={showBlockTextForArtworkId() == x.Id}>
                                        <div class="gallery-image-overlay" style="width: 150px;">
                                            <p class="title">{x.Title}</p>
                                            <p class="salon">by {x.Artist.FirstName} {x.Artist.LastName} <Show when={!!x.DateRange}>[{x.DateRange}]</Show></p>
                                        </div>
                                    </Show>
                                </a>
                            </div>
                        </div>
                    }</For>
                </div>
            </div>
        </div>
    </>
  );      
};